(() => {
  if (customElements.get('product-card')) return;

  class ProductCard extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.variants) return;

      try {
        this.variants = JSON.parse(this.dataset.variants);
      } catch {
        return;
      }

      this.pills = this.querySelectorAll('[data-variant-pill]');
      if (!this.pills.length) return;

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          this._selectVariant(pill);
        });
      });
    }

    _selectVariant(pill) {
      const variantId = parseInt(pill.dataset.variantPill, 10);
      const variant = this.variants.find((v) => v.id === variantId);
      if (!variant) return;

      // --- Pills active state ---
      this.pills.forEach((p) => {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      // --- Update variant in links ---
      this.querySelectorAll('[data-card-url]').forEach((link) => {
        link.href = link.dataset.cardUrl + '?variant=' + variantId;
      });

      // --- Sold out badge ---
      const soldoutEl = this.querySelector('[data-card-soldout]');
      if (soldoutEl) {
        soldoutEl.classList.toggle('is-visible', !variant.available);
      }

      // --- Toggle ATC / notify based on variant availability ---
      const responsiveClass = window.innerWidth < 768 ? 'desktop-hide' : 'mobile-hide';
      this.querySelectorAll('[data-card-atc]').forEach((form) => {
        if (form.classList.contains(responsiveClass)) {
          form.style.display = variant.available ? '' : 'none';
        }
      });
      this.querySelectorAll('[data-card-notify]').forEach((notify) => {
        if (notify.classList.contains(responsiveClass)) {
          notify.style.display = variant.available ? 'none' : '';
        }
      });

      // --- Price ---
      const priceCurrentEl = this.querySelector('[data-card-price-current]');
      const priceCompareEl = this.querySelector('[data-card-price-compare]');

      if (priceCurrentEl) {
        priceCurrentEl.textContent = variant.price_formatted;
        // Reset any inline colour applied for non-sale state
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCurrentEl.style.color = '';
        } else {
          priceCurrentEl.style.color = '#000';
        }
      }

      if (priceCompareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompareEl.textContent = variant.compare_at_price_formatted;
          priceCompareEl.style.display = '';
        } else {
          priceCompareEl.textContent = '';
          priceCompareEl.style.display = 'none';
        }
      }

      // --- Form hidden inputs (desktop + mobile forms) ---
      this.querySelectorAll('[data-card-variant-id]').forEach((input) => {
        input.value = variantId;
      });

      // --- Image swap (only when variant has its own image) ---
      if (!variant.image_url) return;

      const imgWrapper = this.querySelector('[data-card-img-wrapper]');
      if (!imgWrapper) return;

      const img = imgWrapper.querySelector('img');
      const source = imgWrapper.querySelector('source');

      if (img) {
        img.dataset.src = variant.image_url;
        img.src = variant.image_url;
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
      }

      if (source && variant.image_url_mobile) {
        source.dataset.srcset = variant.image_url_mobile;
        source.srcset = variant.image_url_mobile;
      }
    }
  }

  customElements.define('product-card', ProductCard);
})();
